import React from "react";

const MailIcon = ({ color = "#5D5D5D" }) => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.8387 2.92773H2.16299C1.57678 2.92773 1.10156 3.40296 1.10156 3.98916V13.0113C1.10156 13.5975 1.57678 14.0727 2.16299 14.0727H13.8387C14.4249 14.0727 14.9001 13.5975 14.9001 13.0113V3.98916C14.9001 3.40296 14.4249 2.92773 13.8387 2.92773Z"
        stroke="white"
        strokeWidth="1.71"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.10156 4.25391L7.32153 7.99464C7.51226 8.10661 7.75263 8.16792 8.00085 8.16792C8.24906 8.16792 8.48944 8.10661 8.68016 7.99464L14.9001 4.25391"
        stroke="white"
        strokeWidth="1.71"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default MailIcon;
